import { Controller } from "stimulus"

// This just calls sortable on the list on connect(), and destroy on disconnect
// jQuery UI Sortable (loaded globally in application.js).
export default class extends Controller {
  static targets = ["list"]

  connect() {
    const $ = window.jQuery
    if (!$ || !$.fn || !$.fn.sortable) {
      return
    }

    this.$list = $(this.listTarget)
    this.$list.sortable({
      axis: "y",
      handle: "[data-sortable-handle]",
      tolerance: "pointer",
      cursor: "grabbing",
      opacity: 0.92,
      delay: 0,
      distance: 5,
      placeholder: "column-reorder-placeholder",
      forcePlaceholderSize: true
    })
  }

  disconnect() {
    if (this.$list && this.$list.data("ui-sortable")) {
      this.$list.sortable("destroy")
    }
    this.$list = null
  }
}
